
export const lockCrypto = () => {
	pCloudCrypto.lock();
	HFN.cache.expireMatch('listfolder');
};

